/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createBaseClientRepresentationFromDiscriminatorValue, serializeBaseClientRepresentation } from '../../../../../../models/index.js';
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {V2PatchRequestBody}
 */
// @ts-ignore
export function createV2PatchRequestBodyFromDiscriminatorValue(parseNode) {
    return deserializeIntoV2PatchRequestBody;
}
/**
 * The deserialization information for the current model
 * @param V2PatchRequestBody The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoV2PatchRequestBody(v2PatchRequestBody = {}) {
    return {};
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param V2PatchRequestBody The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeV2PatchRequestBody(writer, v2PatchRequestBody = {}, isSerializingDerivedType = false) {
    if (!v2PatchRequestBody || isSerializingDerivedType) {
        return;
    }
    writer.writeAdditionalData(v2PatchRequestBody.additionalData);
}
/**
 * Uri template for the request builder.
 */
export const V2ItemRequestBuilderUriTemplate = "{+baseurl}/admin/api/{realmName}/clients/v2/{id}";
/**
 * Metadata for all the requests in the request builder.
 */
export const V2ItemRequestBuilderRequestsMetadata = {
    delete: {
        uriTemplate: V2ItemRequestBuilderUriTemplate,
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: V2ItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory: createBaseClientRepresentationFromDiscriminatorValue,
    },
    patch: {
        uriTemplate: V2ItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory: createBaseClientRepresentationFromDiscriminatorValue,
        requestBodyContentType: "application/merge-patch+json",
        requestBodySerializer: serializeV2PatchRequestBody,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    put: {
        uriTemplate: V2ItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory: createBaseClientRepresentationFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeBaseClientRepresentation,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=index.js.map